import Component from '@glimmer/component';

import { hash } from '@ember/helper';

import eq from 'rise-ui/helpers/eq.js';
import update from 'rise-ui/modifiers/update.js';

export default class TabPanelTabComponent extends Component {
  <template>
    {{#let (eq @selectedTab @name) as | isSelected |}}
    <div
      class="r-tabs-panel r-tabs-state-{{if isSelected "active" "default"}}"
      title={{@title}}
      {{update @setTab @name (hash title=@title)}}
      ...attributes
    >
      {{~yield~}}
    </div>
    {{/let}}
  </template>
}
